var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('List',{attrs:{"headers":_vm.headers,"formview":_vm.formview,"table":_vm.table,"addbutton":false,"default_limit":'500',"default_sort":'id',"default_sort_typ":'ASC',"extension":''}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }